module.exports = __webpack_public_path__ + "static/7-34dc6b5a16b60003839cf5914fce9247.jpeg";